// TODO remove @colonist/i18n usage
(function(TimeUtils) {
    TimeUtils.MILLISECONDS = 1000;
    TimeUtils.SECONDS_IN_MINUTE = 60;
    TimeUtils.SECONDS_IN_HOUR = 3600;
    TimeUtils.MINUTES_IN_HOUR = 60;
    TimeUtils.SECONDS_IN_DAY = 86400;
    TimeUtils.HOURS_IN_DAY = 24;
    TimeUtils.DAYS_IN_WEEK = 7;
    TimeUtils.DAYS_IN_MONTH = 30;
    TimeUtils.DAYS_IN_YEAR = 365.25;
    TimeUtils.WEEKS_IN_MONTH = TimeUtils.DAYS_IN_MONTH / TimeUtils.DAYS_IN_WEEK;
    TimeUtils.MONTHS_IN_YEAR = 12;
    (function(TimeType) {
        TimeType["Day"] = "day";
        TimeType["Hour"] = "hour";
        TimeType["Minute"] = "minute";
    })(TimeUtils.TimeType || (TimeUtils.TimeType = {}));
    function isDatePassed(stringDate) {
        const date = new Date(stringDate);
        const now = new Date();
        if (now > date) return true;
        return false;
    }
    TimeUtils.isDatePassed = isDatePassed;
    function isDateInTheFuture(date) {
        if (date == undefined) return false;
        if (new Date() < date) return true;
        return false;
    }
    TimeUtils.isDateInTheFuture = isDateInTheFuture;
    function millisecondsLeftInUTCDay(today) {
        const hoursLeftInCurrentDay = TimeUtils.HOURS_IN_DAY - today.getUTCHours() - 1;
        const minutesLeftInCurrentHour = TimeUtils.MINUTES_IN_HOUR - today.getUTCMinutes() - 1;
        const secondsLeftInCurrentMinute = TimeUtils.SECONDS_IN_MINUTE - today.getUTCSeconds() - 1;
        const millisecondsLeftInCurrentSecond = TimeUtils.MILLISECONDS - today.getUTCMilliseconds() - 1;
        const secondsLeftInDay = secondsLeftInCurrentMinute + minutesLeftInCurrentHour * TimeUtils.SECONDS_IN_MINUTE + hoursLeftInCurrentDay * TimeUtils.SECONDS_IN_HOUR;
        const millisecondsLeftInDay = secondsLeftInDay * TimeUtils.MILLISECONDS + millisecondsLeftInCurrentSecond;
        return millisecondsLeftInDay;
    }
    TimeUtils.millisecondsLeftInUTCDay = millisecondsLeftInUTCDay;
    function getDate(theDate) {
        const year = theDate.getFullYear();
        const month = String(theDate.getMonth() + 1).padStart(2, '0');
        const day = String(theDate.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }
    TimeUtils.getDate = getDate;
    function getDateTime(theDate) {
        const date = getDate(theDate);
        const hour = String(theDate.getHours()).padStart(2, '0');
        const minute = String(theDate.getMinutes()).padStart(2, '0');
        const second = String(theDate.getSeconds()).padStart(2, '0');
        return `${date}-${hour}-${minute}-${second}`;
    }
    TimeUtils.getDateTime = getDateTime;
    function getHoursAgoInTimestampFormat(hour) {
        const hoursAgo = hour * TimeUtils.MINUTES_IN_HOUR * TimeUtils.SECONDS_IN_MINUTE * TimeUtils.MILLISECONDS;
        return Math.floor((Date.now() - hoursAgo) / TimeUtils.MILLISECONDS);
    }
    TimeUtils.getHoursAgoInTimestampFormat = getHoursAgoInTimestampFormat;
    function convertTimestampToDateTimeText(time) {
        const date = new Date(Number(time));
        const dateFormatParams = {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        };
        return {
            key: 'strings:colonistCommon.utils.#date',
            options: {
                value: date,
                formatParams: {
                    value: dateFormatParams
                }
            }
        };
    }
    TimeUtils.convertTimestampToDateTimeText = convertTimestampToDateTimeText;
    function timeToString(time) {
        const doubleDigitHourStartingPoint = 10;
        const sliceLetterAmount = -2;
        const totalSeconds = time / TimeUtils.MILLISECONDS;
        const hour = Math.floor(totalSeconds / (TimeUtils.MINUTES_IN_HOUR * TimeUtils.SECONDS_IN_MINUTE));
        const min = Math.floor(totalSeconds % TimeUtils.SECONDS_IN_HOUR / TimeUtils.SECONDS_IN_MINUTE);
        const sec = Math.floor(totalSeconds % TimeUtils.SECONDS_IN_MINUTE);
        let newHour = '';
        if (hour < doubleDigitHourStartingPoint) {
            newHour = ('0' + hour).slice(sliceLetterAmount);
        } else {
            newHour = hour.toString();
        }
        return newHour + ':' + ('0' + min).slice(sliceLetterAmount) + ':' + ('0' + sec).slice(sliceLetterAmount);
    }
    TimeUtils.timeToString = timeToString;
    function timePadding(time) {
        const doubleDigitHourStartingPoint = 10;
        return time < doubleDigitHourStartingPoint ? '0' + time.toString() : time.toString();
    }
    TimeUtils.timePadding = timePadding;
    function getUTCTimeString(time) {
        const dateTime = new Date(time);
        return dateTime.toUTCString();
    }
    TimeUtils.getUTCTimeString = getUTCTimeString;
    function minutesPassedSince(time) {
        const now = Date.now();
        const difference = now - time;
        const totalSeconds = difference / TimeUtils.MILLISECONDS;
        return Math.round(totalSeconds / TimeUtils.SECONDS_IN_MINUTE);
    }
    // Estimation of minutes, not accurate under 5 minutes, use millisecondsPassedSince instead
    TimeUtils.minutesPassedSince = minutesPassedSince;
    function millisecondsPassedSince(time) {
        const now = Date.now();
        return now - time;
    }
    TimeUtils.millisecondsPassedSince = millisecondsPassedSince;
    function isThisLastMonth(time, from = Date.now()) {
        const hour = TimeUtils.MILLISECONDS * TimeUtils.SECONDS_IN_MINUTE * TimeUtils.MINUTES_IN_HOUR;
        const day = hour * TimeUtils.HOURS_IN_DAY;
        const month = day * TimeUtils.DAYS_IN_MONTH;
        const aMonthAgo = from - month;
        return time > aMonthAgo;
    }
    TimeUtils.isThisLastMonth = isThisLastMonth;
    function isThisLastYear(time, from = Date.now()) {
        const hour = TimeUtils.MILLISECONDS * TimeUtils.SECONDS_IN_MINUTE * TimeUtils.MINUTES_IN_HOUR;
        const day = hour * TimeUtils.HOURS_IN_DAY;
        const month = day * TimeUtils.DAYS_IN_MONTH;
        const year = month * TimeUtils.MONTHS_IN_YEAR;
        const aYearAgo = from - year;
        return time > aYearAgo;
    }
    TimeUtils.isThisLastYear = isThisLastYear;
    function secondsLeftForCurrentState(timeLeft) {
        return timeLeft < 0 ? 0 : Math.round(timeLeft);
    }
    TimeUtils.secondsLeftForCurrentState = secondsLeftForCurrentState;
    function yesterdayDate() {
        return adjustDateByDays(-1);
    }
    // https://stackoverflow.com/a/20863404/2589276
    TimeUtils.yesterdayDate = yesterdayDate;
    function getWeekNumber(milliseconds) {
        const date = new Date(milliseconds);
        // Set to nearest Thursday: current date + 4 - current day number
        // Make Sunday's day number 7
        // noinspection TsLint Don't know what these values are
        date.setUTCDate(date.getUTCDate() + 4 - (date.getUTCDay() || 7));
        // Get first day of year
        const yearStart = new Date(Date.UTC(date.getUTCFullYear(), 0, 1));
        // Calculate full weeks to nearest Thursday
        // noinspection TsLint Don't know what these values are
        const weekNo = Math.ceil(((+date - +yearStart) / 86400000 + 1) / 7);
        // Return array of year and week number
        return [
            weekNo,
            date.getUTCFullYear()
        ];
    }
    // https://stackoverflow.com/a/6117889/2589276
    TimeUtils.getWeekNumber = getWeekNumber;
    function getDaysHoursMinutesBetweenDates(futureDate, pastDate) {
        let deltaSeconds = (futureDate.getTime() - pastDate.getTime()) / TimeUtils.MILLISECONDS;
        const deltaDays = Math.floor(deltaSeconds / DurationConverter.daysAsSeconds(1));
        deltaSeconds -= DurationConverter.daysAsSeconds(deltaDays);
        const deltaHours = Math.floor(deltaSeconds / DurationConverter.hoursAsSeconds(1)) % TimeUtils.HOURS_IN_DAY;
        deltaSeconds -= DurationConverter.hoursAsSeconds(deltaHours);
        const deltaMinutes = Math.floor(deltaSeconds / DurationConverter.minutesAsSeconds(1)) % TimeUtils.SECONDS_IN_MINUTE;
        deltaSeconds -= DurationConverter.minutesAsSeconds(deltaMinutes);
        return {
            days: deltaDays,
            hours: deltaHours,
            minutes: deltaMinutes
        };
    }
    // https://stackoverflow.com/a/13904120/14006099
    TimeUtils.getDaysHoursMinutesBetweenDates = getDaysHoursMinutesBetweenDates;
    function getDaysHoursMinutesBetweenDatesString(futureDate, pastDate) {
        const deltaDaysHoursMinutes = getDaysHoursMinutesBetweenDates(futureDate, pastDate);
        return `${deltaDaysHoursMinutes.days} days ${deltaDaysHoursMinutes.hours} hours ${deltaDaysHoursMinutes.minutes} minutes`;
    }
    TimeUtils.getDaysHoursMinutesBetweenDatesString = getDaysHoursMinutesBetweenDatesString;
    function getDaysHoursOrMinutesBetweenDates(futureDate, pastDate) {
        const deltaDaysHoursMinutes = getDaysHoursMinutesBetweenDates(futureDate, pastDate);
        const { days, hours, minutes } = deltaDaysHoursMinutes;
        if (days > 0) return {
            dateType: "day",
            duration: days
        };
        if (hours > 0) return {
            dateType: "hour",
            duration: hours
        };
        return {
            dateType: "minute",
            duration: minutes
        };
    }
    TimeUtils.getDaysHoursOrMinutesBetweenDates = getDaysHoursOrMinutesBetweenDates;
    function getOneWeekInThePast() {
        return adjustDateByDays(-TimeUtils.DAYS_IN_WEEK);
    }
    TimeUtils.getOneWeekInThePast = getOneWeekInThePast;
    function getOneWeekInTheFuture() {
        return adjustDateByDays(TimeUtils.DAYS_IN_WEEK);
    }
    TimeUtils.getOneWeekInTheFuture = getOneWeekInTheFuture;
    function getNDaysInThePast(days) {
        return adjustDateByDays(-days);
    }
    TimeUtils.getNDaysInThePast = getNDaysInThePast;
    function adjustDateByDays(days, date = new Date()) {
        return new Date(date.getTime() + DurationConverter.daysAsMilliseconds(days));
    }
    TimeUtils.adjustDateByDays = adjustDateByDays;
    function adjustDateByMinutes(minutes, date = new Date()) {
        return new Date(date.getTime() + DurationConverter.minutesAsMilliseconds(minutes));
    }
    TimeUtils.adjustDateByMinutes = adjustDateByMinutes;
    function adjustDateByMilliseconds(milliseconds, date = new Date()) {
        return new Date(date.getTime() + milliseconds);
    }
    TimeUtils.adjustDateByMilliseconds = adjustDateByMilliseconds;
    function formatSecondsToElapsedString(seconds) {
        const hours = Math.floor(seconds / TimeUtils.SECONDS_IN_HOUR);
        const minutes = Math.floor((seconds - hours * TimeUtils.SECONDS_IN_HOUR) / TimeUtils.SECONDS_IN_MINUTE);
        const remainingSeconds = Math.floor(seconds - hours * TimeUtils.SECONDS_IN_HOUR - minutes * TimeUtils.SECONDS_IN_MINUTE);
        let formattedTime = minutes.toString().padStart(2, '0') + ':' + remainingSeconds.toString().padStart(2, '0');
        if (hours) formattedTime = hours.toString().padStart(2, '0') + ':' + formattedTime;
        return formattedTime;
    }
    TimeUtils.formatSecondsToElapsedString = formatSecondsToElapsedString;
    function absoluteDifferenceInDays(startDate, endDate) {
        const difference = Math.abs(startDate.getTime() - endDate.getTime());
        return difference / (TimeUtils.MILLISECONDS * TimeUtils.SECONDS_IN_MINUTE * TimeUtils.MINUTES_IN_HOUR * TimeUtils.HOURS_IN_DAY);
    }
    TimeUtils.absoluteDifferenceInDays = absoluteDifferenceInDays;
    function differenceInDays(startDate, endDate) {
        const difference = endDate.getTime() - startDate.getTime();
        return difference / (TimeUtils.MILLISECONDS * TimeUtils.SECONDS_IN_MINUTE * TimeUtils.MINUTES_IN_HOUR * TimeUtils.HOURS_IN_DAY);
    }
    TimeUtils.differenceInDays = differenceInDays;
    function isDateInBetween(startDate, endDate, dateToCheck) {
        return startDate <= dateToCheck && dateToCheck <= endDate;
    }
    TimeUtils.isDateInBetween = isDateInBetween;
    function addYears(date, numberOfYears) {
        const result = new Date(date.getTime());
        result.setUTCFullYear(result.getUTCFullYear() + numberOfYears);
        return result;
    }
    TimeUtils.addYears = addYears;
    function toDate(date) {
        if (date instanceof Date) return date;
        return new Date(date);
    }
    TimeUtils.toDate = toDate;
    function getStartOfDay(date) {
        return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), 0, 0, 0, 0));
    }
    TimeUtils.getStartOfDay = getStartOfDay;
    function getEndOfDay(date) {
        return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), 23, 59, 59, 999));
    }
    TimeUtils.getEndOfDay = getEndOfDay;
    function formatDateDistance(olderDate, newerDate) {
        const daysDiff = absoluteDifferenceInDays(olderDate, newerDate);
        if (daysDiff < 1) return {
            key: 'strings:colonistCommon.dates.day',
            options: {
                count: 1
            }
        };
        if (daysDiff < TimeUtils.DAYS_IN_MONTH) return {
            key: 'strings:colonistCommon.dates.day',
            options: {
                count: Math.round(daysDiff)
            }
        };
        const monthsDiff = daysDiff / TimeUtils.DAYS_IN_MONTH;
        return {
            key: 'strings:colonistCommon.dates.month',
            options: {
                count: Math.round(monthsDiff)
            }
        };
    }
    TimeUtils.formatDateDistance = formatDateDistance;
    function formatCountdownString(date) {
        const now = new Date();
        const milliseconds = date.getTime() - now.getTime();
        const totalSeconds = milliseconds / TimeUtils.MILLISECONDS;
        const days = totalSeconds / TimeUtils.SECONDS_IN_DAY;
        if (days >= 1) return `${Math.floor(days)}d`;
        const hours = totalSeconds / TimeUtils.SECONDS_IN_HOUR;
        if (hours >= 1) return `${Math.floor(hours)}h`;
        const minutes = totalSeconds / TimeUtils.SECONDS_IN_MINUTE;
        if (minutes >= 1) return `${Math.floor(minutes)}m`;
        const seconds = totalSeconds % TimeUtils.SECONDS_IN_MINUTE;
        if (seconds >= 1) return `${Math.floor(seconds)}s`;
        return '0s';
    }
    TimeUtils.formatCountdownString = formatCountdownString;
    function getAdaptiveCountdownPollIntervalMs(remainingMs) {
        const dayMs = DurationConverter.daysAsMilliseconds(1);
        const hourMs = DurationConverter.hoursAsMilliseconds(1);
        const minuteMs = DurationConverter.minutesAsMilliseconds(1);
        const secondMs = DurationConverter.secondsAsMilliseconds(1);
        if (remainingMs >= dayMs) return hourMs;
        if (remainingMs >= hourMs) return minuteMs;
        if (remainingMs <= minuteMs) return secondMs;
        return Math.min(minuteMs, remainingMs - minuteMs);
    }
    TimeUtils.getAdaptiveCountdownPollIntervalMs = getAdaptiveCountdownPollIntervalMs;
    function getTimeAgoTextFromDate(date) {
        const now = new Date();
        const secondsAgo = Math.floor((now.getTime() - date.getTime()) / TimeUtils.MILLISECONDS);
        if (secondsAgo < TimeUtils.SECONDS_IN_MINUTE) return {
            key: 'strings:popups.notification.timeAbbreviations.second',
            options: {
                count: secondsAgo
            }
        };
        const minutesAgo = Math.floor(secondsAgo / TimeUtils.SECONDS_IN_MINUTE);
        if (minutesAgo < TimeUtils.MINUTES_IN_HOUR) return {
            key: 'strings:popups.notification.timeAbbreviations.minute',
            options: {
                count: minutesAgo
            }
        };
        const hoursAgo = Math.floor(minutesAgo / TimeUtils.MINUTES_IN_HOUR);
        if (hoursAgo < TimeUtils.HOURS_IN_DAY) return {
            key: 'strings:popups.notification.timeAbbreviations.hour',
            options: {
                count: hoursAgo
            }
        };
        const daysAgo = Math.floor(hoursAgo / TimeUtils.HOURS_IN_DAY);
        if (daysAgo < TimeUtils.DAYS_IN_WEEK) return {
            key: 'strings:popups.notification.timeAbbreviations.day',
            options: {
                count: daysAgo
            }
        };
        const weeksAgo = Math.floor(daysAgo / TimeUtils.DAYS_IN_WEEK);
        if (weeksAgo < TimeUtils.WEEKS_IN_MONTH) return {
            key: 'strings:popups.notification.timeAbbreviations.week',
            options: {
                count: weeksAgo
            }
        };
        const monthsAgo = Math.floor(daysAgo / TimeUtils.DAYS_IN_MONTH);
        if (monthsAgo < TimeUtils.MONTHS_IN_YEAR) return {
            key: 'strings:popups.notification.timeAbbreviations.month',
            options: {
                count: monthsAgo
            }
        };
        const yearsAgo = Math.floor(daysAgo / TimeUtils.DAYS_IN_YEAR);
        return {
            key: 'strings:popups.notification.timeAbbreviations.year',
            options: {
                count: yearsAgo
            }
        };
    }
    TimeUtils.getTimeAgoTextFromDate = getTimeAgoTextFromDate;
})(TimeUtils || (TimeUtils = {}));
(function(DurationConverter) {
    function secondsAsMilliseconds(seconds) {
        return seconds * TimeUtils.MILLISECONDS;
    }
    DurationConverter.secondsAsMilliseconds = secondsAsMilliseconds;
    function minutesAsMilliseconds(minutes) {
        return minutes * secondsAsMilliseconds(TimeUtils.SECONDS_IN_MINUTE);
    }
    DurationConverter.minutesAsMilliseconds = minutesAsMilliseconds;
    function hoursAsMilliseconds(hours) {
        return hours * minutesAsMilliseconds(TimeUtils.MINUTES_IN_HOUR);
    }
    DurationConverter.hoursAsMilliseconds = hoursAsMilliseconds;
    function daysAsMilliseconds(days) {
        return days * hoursAsMilliseconds(TimeUtils.HOURS_IN_DAY);
    }
    DurationConverter.daysAsMilliseconds = daysAsMilliseconds;
    function weeksAsMilliseconds(weeks) {
        return weeks * daysAsMilliseconds(TimeUtils.DAYS_IN_WEEK);
    }
    DurationConverter.weeksAsMilliseconds = weeksAsMilliseconds;
    function monthsAsMilliseconds(months) {
        return months * daysAsMilliseconds(TimeUtils.DAYS_IN_MONTH);
    }
    DurationConverter.monthsAsMilliseconds = monthsAsMilliseconds;
    function minutesAsSeconds(minutes) {
        return minutes * TimeUtils.SECONDS_IN_MINUTE;
    }
    DurationConverter.minutesAsSeconds = minutesAsSeconds;
    function hoursAsSeconds(hours) {
        return hours * minutesAsSeconds(TimeUtils.MINUTES_IN_HOUR);
    }
    DurationConverter.hoursAsSeconds = hoursAsSeconds;
    function daysAsSeconds(days) {
        return days * hoursAsSeconds(TimeUtils.HOURS_IN_DAY);
    }
    DurationConverter.daysAsSeconds = daysAsSeconds;
    function weeksAsSeconds(weeks) {
        return weeks * daysAsSeconds(TimeUtils.DAYS_IN_WEEK);
    }
    DurationConverter.weeksAsSeconds = weeksAsSeconds;
    function monthsAsSeconds(months) {
        return months * daysAsSeconds(TimeUtils.DAYS_IN_MONTH);
    }
    DurationConverter.monthsAsSeconds = monthsAsSeconds;
})(DurationConverter || (DurationConverter = {}));
export var TimeUtils, DurationConverter;
